<!-- <suvo-bi-channel-debug-label [filtersChannel]="filtersChannel"></suvo-bi-channel-debug-label> -->

<!-- <div class="debug-info-box">
  <p>{{ filters | json }}</p>
</div> -->

<!-- <p>{{ debugNumber }} , {{ filtersChannel?.channelName }} , {{ filtersChannel?.selectedFilters?.name }} , {{ selectedFilters?.name }}</p> -->

<div
  *ngIf="filters"
  class="container flex-1 d-flex fd-col ai-stretch"
  [ngClass]="{ 'controls-disabled': controlsDisabled }"
>
  <div
    class="edit-section d-flex fd-col ai-stretch"
    style="flex: 0 1"
  >
    <!-- Sections -->
    <div class="d-flex fd-col ai-stretch">
      <ng-container
        *ngFor="let section of filtersSections.sections; let lastSection = last"
      >
        <div
          class="d-flex ai-stretch"
          [ngClass]="!verticalOnly && section.asRow ? 'fd-row' : 'fd-col'"
        >
          <ng-container
            *ngFor="let option of section.columns; let lastOption = last"
          >
            <suvo-bi-section-wrapper
              class="section-wrapper"
              [option]="option"
              (rulesChanged)="rulesChanged()"
            >
            </suvo-bi-section-wrapper>
            <!-- <mat-divider [vertical]="true" *ngIf="!lastOption"></mat-divider> -->
          </ng-container>
        </div>
        <!-- <mat-divider *ngIf="!lastSection"></mat-divider> -->
      </ng-container>
    </div>
  </div>
</div>
